import Loadable from 'react-loadable';
import { Preloader } from '../../components/Loading';

export default Loadable({
  loader: () => import('./DnDRoutes.js'),
  loading: Preloader,
});



// WEBPACK FOOTER //
// ./src/containers/app/DnDLoadable.js